// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__S_D61","tinted":"styles_tinted__4g3QQ","darker":"styles_darker__J0puF"};